import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-named-as-default
import DateStamp from '@stubhub/react-date-stamp';

const EventDate = ({eventDate, disableDateStamp, timeDisplay}) => {
  if (disableDateStamp) {
    return null;
  }

  return (
    <div className="EventItem__Date">
      <DateStamp date={eventDate} time={timeDisplay} />
    </div>
  );
};

EventDate.propTypes = {
  /** The date of the event */
  eventDate: PropTypes.oneOf([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,

  /** If true, disables rendering of the date stamp */
  disableDateStamp: PropTypes.bool,

  /** The time display for the event */
  timeDisplay: PropTypes.string,
};

export default EventDate;
